<gbc-tile [title]="'dumbledore-schematics-tile.title' | translate" data-test-id="schematics-tile">
  @if (isMixit$ | async) {
    <div gbc-tile-left class="license-label">
      @if ((isConnect$ | async) && ((isDynamic$ | async) === false)) {
        {{'schematic.connect' | translate}}
      }
      @if ((isDynamic$ | async) && ((isConnect$ | async) === false)) {
        {{'schematic.dynamic' | translate}}
      }
      @if (((isDynamic$ | async) === false) && ((isConnect$ | async) === false)) {
        {{'schematic.freemium' | translate}}
      }
      @if ((isDynamic$ | async) && (isConnect$ | async)) {
        {{'schematic.connect' | translate}} + {{'schematic.dynamic' | translate}}
      }
    </div>
  }
  <div class="title-right" gbc-tile-right>
    <app-last-updated [installationId]="installationId" [applicationId]="applicationId"></app-last-updated>
    <button gbc-icon-button gbc-tile-right
      class="fullscreen-button"
      (click)="fullscreen()"
      angulartics2On="click"
      angularticsAction="expandViewClicked"
      angularticsCategory="schematic">
      <img src="./assets/svgs/fullscreen.svg" alt="full screen">
    </button>
  </div>
  <div #dumbledore class="dumbledore" [ngStyle]="{height: height + 'px'}"></div>
</gbc-tile>
